module.exports = __webpack_public_path__ + "app/principal/routing/modal-pdp-routing-code/modal-unupdated-pdp-routing-code-K-dcFwa0.html";